
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-f8ce6c15d3";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("kTri3", function(module, exports) {

$parcel$export(module.exports, "TryPage", function () { return $cab6b90ee0aec048$export$609689a2a01efdbc; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("ociJF");
var $3asrx = parcelRequire("3asrx");
const $cab6b90ee0aec048$export$609689a2a01efdbc = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3asrx.TryPageTemplate), {});

});
parcelRegister("ociJF", function(module, exports) {

$parcel$export(module.exports, "TryPageTemplate", function () { return (parcelRequire("3asrx")).TryPageTemplate; });

var $3asrx = parcelRequire("3asrx");

});
parcelRegister("3asrx", function(module, exports) {

$parcel$export(module.exports, "TryPageTemplate", function () { return $4c8430ff1444e406$export$86c5cc40b74df40f; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $9iWJ8 = parcelRequire("9iWJ8");

var $51uXk = parcelRequire("51uXk");

var $eVI4d = parcelRequire("eVI4d");

var $lXF4x = parcelRequire("lXF4x");

var $1dD1u = parcelRequire("1dD1u");

var $l7FNA = parcelRequire("l7FNA");

var $lPcTp = parcelRequire("lPcTp");

var $g5q4i = parcelRequire("g5q4i");

var $1SKTn = parcelRequire("1SKTn");
const $4c8430ff1444e406$export$86c5cc40b74df40f = ()=>{
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).dxpMigrationSoftwarePage);
    (0, $iSvIT.useEffect)(()=>{
        if (!dxpMigrationExposureFired) fireDxpMigrationExposure();
    }, [
        dxpMigrationExposureFired,
        fireDxpMigrationExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: false,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "try"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $l7FNA.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $g5q4i.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1SKTn.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eVI4d.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $51uXk.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $lPcTp.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1dD1u.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $lXF4x.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("51uXk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $022d2a8bb07c82aa$export$2e2bcd8739ae039; });
/* code-build-ship-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $022d2a8bb07c82aa$var$sectionCss = null;
const $022d2a8bb07c82aa$var$CodeBuildShipSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });
    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage: "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });
    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage: "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });
    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage: "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });
    const rovoDevBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.rovoDev.bodyText",
        defaultMessage: "Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle."
    });
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const downloadNow = intl.formatMessage((0, $gxrnF.messages).downloadNow);
    const bitbucketLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    });
    const rovoLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "rovodev",
        type: "logo",
        appearance: "brand"
    });
    const sourcetreeLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "sourcetree",
        type: "logo",
        appearance: "brand"
    });
    const compassLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "code-build-ship",
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                    dividerColor: "#ff8b00",
                    headerText: codeBuildShipHeaderText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: bitbucketLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/bundle"),
                        bodyText: bitbucketBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: rovoLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=devai"),
                        bodyText: rovoDevBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: sourcetreeLogo,
                        link: "https://www.sourcetreeapp.com/",
                        bodyText: sourcetreeBody,
                        ctaText: downloadNow
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: compassLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass"),
                        bodyText: compassBody,
                        ctaText: tryCloud
                    })
                ]
            })
        ]
    });
};
var $022d2a8bb07c82aa$export$2e2bcd8739ae039 = $022d2a8bb07c82aa$var$CodeBuildShipSection;

});
parcelRegister("lkWcW", function(module, exports) {

$parcel$export(module.exports, "TryPageCard", function () { return (parcelRequire("dCRJL")).TryPageCard; });
$parcel$export(module.exports, "TryPageHeader", function () { return (parcelRequire("bjFQv")).TryPageHeader; });

var $dCRJL = parcelRequire("dCRJL");

var $bjFQv = parcelRequire("bjFQv");

});
parcelRegister("dCRJL", function(module, exports) {

$parcel$export(module.exports, "TryPageCard", function () { return $50f9be0a65972998$export$78a2651bc04a8175; });
/* try-page-card.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bQawl = parcelRequire("bQawl");
const $50f9be0a65972998$var$pStyle = null;
const $50f9be0a65972998$var$tryPageCardStyles = null;
const $50f9be0a65972998$var$logoBlockStyles = null;
const $50f9be0a65972998$var$StyledLogo = (logo)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1752zwfg _w8l51wug _4x201osq"
        ]),
        children: logo
    });
};
const $50f9be0a65972998$export$78a2651bc04a8175 = (props)=>{
    const { title: title, logo: logo, link: link, bodyText: bodyText, ctaText: ctaText, buttonColor: buttonColor, buttonType: buttonType } = props;
    const styledLogo = logo && $50f9be0a65972998$var$StyledLogo(logo);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            styledLogo && /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                href: link,
                children: styledLogo
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wyb1j6v _1pfhgrf3 _6rth1tcg",
                    "tryCardText"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.Button), {
                className: "ctaButton",
                text: ctaText,
                type: buttonType !== null && buttonType !== void 0 ? buttonType : "secondary",
                url: link,
                size: "small",
                color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "darkblue",
                dataEventProps: {
                    "data-product-key": "try",
                    "data-event-component": "linkButton",
                    "data-event-container": "cardSection",
                    "data-event": "clicked",
                    "data-label": ctaText
                }
            })
        ]
    });
};

});

parcelRegister("bjFQv", function(module, exports) {

$parcel$export(module.exports, "TryPageHeader", function () { return $08bbc3641997729e$export$d30aca31b48239d; });
/* try-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $ix9oc = parcelRequire("ix9oc");
const $08bbc3641997729e$export$d30aca31b48239d = (props)=>{
    const { dividerColor: dividerColor, headerText: headerText } = props;
    const headerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4f1d1bqd _z5uk7vkz _1boa7vkz _16itidpf _ad5cidpf _4rmj11ph _16niidpf _1132idpf _19abftgi _edooidpf _rzyb1k8s _1apkdlk8 _1x4qahaf _hkvxdlk8 _sizi1tcg _11o6bmm0 _u25g1y44 _19ed7vkz _pgbz11ux _2z90idpf _1mvaidpf"
        ]),
        style: {
            "--_ei0dq9": (0, $43MIc.default)(dividerColor)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
            headerText: headerText,
            headerType: "h2",
            horizontalRule: true
        })
    });
};

});


parcelRegister("gxrnF", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $2a8d719bd7cf1a79$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $2a8d719bd7cf1a79$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    tryCloud: {
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    },
    downloadNow: {
        id: "TryPageTemplate.downloadNow",
        defaultMessage: "Download now"
    }
});

});


parcelRegister("eVI4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dabf38a715bba18$export$2e2bcd8739ae039; });
/* collaborate-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $3dabf38a715bba18$var$sectionCss = null;
const $3dabf38a715bba18$var$CollaborateSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: "TryPageTemplate.collaborate.title",
        defaultMessage: "Collaborate"
    });
    const confluenceBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.confluenceBody",
        defaultMessage: "Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place."
    });
    const trelloBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.trelloBody",
        defaultMessage: "Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way."
    });
    const loomBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.loomBody",
        defaultMessage: "Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform."
    });
    const confluenceLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    });
    const trelloLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "trello",
        type: "logo",
        appearance: "brand"
    });
    const loomLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "loom",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "collaborateCards",
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                    headerText: collaborateTitle,
                    dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: confluenceLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/software/confluence/free"),
                        bodyText: confluenceBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: trelloLogo,
                        link: "https://www.trello.com/signup",
                        bodyText: trelloBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                        logo: loomLogo,
                        link: (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium"),
                        bodyText: loomBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
                ]
            })
        ]
    });
};
var $3dabf38a715bba18$export$2e2bcd8739ae039 = $3dabf38a715bba18$var$CollaborateSection;

});

parcelRegister("lXF4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c22e2f62e2e6dd0$export$2e2bcd8739ae039; });
/* enterprise-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $dCRJL = parcelRequire("dCRJL");
const $7c22e2f62e2e6dd0$var$sectionCss = null;
const $7c22e2f62e2e6dd0$var$headerStyle = null;
const $7c22e2f62e2e6dd0$var$lowerCss = null;
const $7c22e2f62e2e6dd0$var$imageCss = null;
const $7c22e2f62e2e6dd0$var$EnterpriseSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const goBigHeader = intl.formatMessage({
        id: "try.enterprise.goBig",
        defaultMessage: "Go big with Atlassian Enterprise"
    });
    const goBigBody = intl.formatMessage({
        id: "try.enterprise.goBigBody",
        defaultMessage: "Connect, accelerate, and scale your entire enterprise with Atlassian enterprise solutions."
    });
    const learnMore = intl.formatMessage({
        id: "try.enterprise.learnMore",
        defaultMessage: "Learn more"
    });
    const cloud = intl.formatMessage({
        id: "try.enterprise.cloud",
        defaultMessage: "Cloud"
    });
    const cloudBody = intl.formatMessage({
        id: "try.enterprise.cloudBody",
        defaultMessage: "Atlassian cloud solutions are equipped with everything large and growing teams need to scale collaboration and workflows seamlessly."
    });
    const dataCenter = intl.formatMessage({
        id: "try.enterprise.dataCenter",
        defaultMessage: "Data Center"
    });
    const dataCenterBody = intl.formatMessage({
        id: "try.enterprise.dataCenterBody",
        defaultMessage: "Host our applications with IaaS vendors like AWS or Azure. Data Center is our self-managed solution for advanced administration at scale."
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_syazcd5j _bfhk1ep1 _ca0q12bs _u5f3idpf _n3td12bs _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_l5k1bfng _11ebahaf _2fhk4jg8 _bpspbfng _1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                        headerText: goBigHeader,
                        headerType: "h2",
                        isCentered: true,
                        bodyText: goBigBody,
                        ctaProps: {
                            buttonProps: {
                                className: "ctaButton",
                                text: learnMore,
                                url: "https://www.atlassian.com/enterprise",
                                type: "primary",
                                color: "lightblue",
                                size: "small"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0 _x3mzbfng _k48p4jg8 _1o6v1j6v _ggmh1k8s _r8nt4jg8 _1adi12sy _19tboxwj _43ds1ep1 _bna711ux"
                ]),
                style: {
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                            title: cloud,
                            link: (0, $3FBn4.useLocalizedHref)("/enterprise/cloud"),
                            bodyText: cloudBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
                            title: dataCenter,
                            link: (0, $3FBn4.useLocalizedHref)("/enterprise/data-center"),
                            bodyText: dataCenterBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1e0c1txw"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
                                    alt: intl.formatMessage({
                                        id: "try.enterprise.databaseServer",
                                        defaultMessage: "Data center + server"
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $7c22e2f62e2e6dd0$export$2e2bcd8739ae039 = $7c22e2f62e2e6dd0$var$EnterpriseSection;

});

parcelRegister("1dD1u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $912ed4874d605be1$export$2e2bcd8739ae039; });
/* get-the-most-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $5VP5O = parcelRequire("5VP5O");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $912ed4874d605be1$var$pageSection = null;
const $912ed4874d605be1$var$sectionCss = null;
const $912ed4874d605be1$var$headerStyle = null;
const $912ed4874d605be1$var$cardContainer = null;
const $912ed4874d605be1$var$GetTheMostSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardData = [
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceHeaderText",
                defaultMessage: "Tailor to your team\u2019s needs"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceBodyText",
                defaultMessage: "Extend your Atlassian products with thousands of apps from Marketplace."
            }),
            callToAction: {
                href: "https://marketplace.atlassian.com/",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.marketplacePrimaryLink",
                    defaultMessage: "Go to Marketplace"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999"
        },
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityHeaderText",
                defaultMessage: "Train with Atlassian University"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityBodyText",
                defaultMessage: "Develop new skills, improve your team\u2019s work, and advance your professional career."
            }),
            callToAction: {
                href: "https://www.atlassian.com/university",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.universityPrimaryLink",
                    defaultMessage: "Go to Atlassian University"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_1q51xy5q _85i5xncg _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_12l21wug _ahbq1wug _1ul91osq _11rm1hrf _bfhkcd5j _kqswh2mm"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _cg411tj6 _l5k1bfng _1pxq7vkz _ygm1idpf _u6q57vkz _sydsidpf _17z411ph _xztqidpf _ubikidpf _j8iydlk8 _h9g4idpf _1kll1ejb _1g9widpf _1kovidpf _bsriidpf _1qsfidpf _1x1pahaf _12adidpf _1xe1idpf _hcanidpf _nji3idpf _j269ahaf"
                        ]),
                        style: {
                            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "TryPageTemplate.getTheMost.header",
                                defaultMessage: "Get the most out of your products"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: cardData.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1ui68ved"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VP5O.Card), (0, $7Knp0._)({}, card))
                        }, index))
                })
            ]
        })
    });
};
var $912ed4874d605be1$export$2e2bcd8739ae039 = $912ed4874d605be1$var$GetTheMostSection;

});

parcelRegister("l7FNA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07014a24a41fc853$export$2e2bcd8739ae039; });
/* hero-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("lJjtp");
var $k2rni = parcelRequire("k2rni");
const $07014a24a41fc853$var$HeroTryGraphCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.bodyText",
        defaultMessage: "Collaborate seamlessly across cross-functional teams, at scale"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.imgAltText",
        defaultMessage: "Connections illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$HeroTryLockCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.bodyText",
        defaultMessage: "Built with industry-leading privacy, security, and data control"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.imgAltText",
        defaultMessage: "Trust and security illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$HeroTryPuzzleCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.bodyText",
        defaultMessage: "Customize your products with 1,000+ apps and integrations"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.imgAltText",
        defaultMessage: "Integration puzzle illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $07014a24a41fc853$var$sectionCssOverride = null;
const $07014a24a41fc853$var$outerContainerCssOverride = null;
const $07014a24a41fc853$var$HeroSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.header",
        defaultMessage: "Try Atlassian apps for free"
    });
    const bodyText = intl.formatMessage({
        id: "TryPageTemplate.hero.bodyText",
        defaultMessage: "Our cloud products empower teams of all types, from startup to enterprise."
    });
    const backgroundProps = {
        bgColor: (0, $5ohHq.wacToken)("color.neutral.light100")
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_cg411tj6 _18oz1wto _1ap71k7u _u8fj1tcg _163midpf _yzu7idpf _1kll14b4 _1qdgidpf _7toc10nf _cjxodlk8 _a5ip1n2x _1f35m24h _ps1ee8xo _z0gn1h6o _p1061k92 _zqtwnl7k _130319ii _10vfidpf _1of01yg0 _1xw61h67 _sz6216xe _3int1gpt _dmb7grf3"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_16qs1cd0 _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k2rni.ContentBlocksInline), {
                headerText: headerText,
                bodyText: bodyText,
                backgroundProperties: backgroundProps,
                inlineContentBlocks: [
                    $07014a24a41fc853$var$HeroTryGraphCard(),
                    $07014a24a41fc853$var$HeroTryLockCard(),
                    $07014a24a41fc853$var$HeroTryPuzzleCard()
                ]
            })
        })
    });
};
var $07014a24a41fc853$export$2e2bcd8739ae039 = $07014a24a41fc853$var$HeroSection;

});
parcelRegister("lJjtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("k2rni")).ContentBlocksInline; });

var $k2rni = parcelRequire("k2rni");

});
parcelRegister("k2rni", function(module, exports) {

$parcel$export(module.exports, "ContentBlocksInline", function () { return $44a7057441067a36$export$4fd59a663df2d810; });
/* content-blocks-inline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $ix9oc = parcelRequire("ix9oc");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");
const $44a7057441067a36$var$getCardAspectRatio = (length)=>{
    switch(length){
        case 4:
            return "4/3";
        case 3:
            return "4/3";
        case 2:
            return "2/1";
        default:
            return "1/1";
    }
};
const $44a7057441067a36$var$ctaStyle = null;
const $44a7057441067a36$export$4fd59a663df2d810 = ({ headerText: headerText, bodyText: bodyText, backgroundProperties: backgroundProperties, className: className, eyebrowText: eyebrowText, iconName: iconName, linkPosition: linkPosition = "bottom", ctaProps: ctaProps, inlineContentBlocks: inlineContentBlocks })=>{
    if (inlineContentBlocks.length < 2 || inlineContentBlocks.length > 4) throw new Error("Pattern is meant to display between 2 and 4 cards");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        iconName: iconName,
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: inlineContentBlocks.map((block, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), (0, $7Knp0._)({
                            aspectRatio: $44a7057441067a36$var$getCardAspectRatio(inlineContentBlocks.length)
                        }, block), index))
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), (0, $7Knp0._)({}, ctaProps.primaryLinkProps))
                    })
                }) : null
            ]
        })
    }));
};

});



parcelRegister("lPcTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b4fa8d38716042$export$2e2bcd8739ae039; });
/* identity-and-security-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");

var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $f8b4fa8d38716042$var$sectionStyles = null;
const $f8b4fa8d38716042$var$IdentityAndSecuritySection = ()=>{
    const intl = (0, $f6qj2.default)();
    const atlassianAccessHeaderText = intl.formatMessage({
        id: "TryPageTemplate.IdentityAndSecurity.title",
        defaultMessage: "Identity & Security"
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
    };
    const atlassianAccessLink = "https://admin.atlassian.com/";
    const atlassianAccessBodyText = intl.formatMessage({
        id: "TryPageTemplate.identityAndSecurity.atlassianAccessBody",
        defaultMessage: "Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure."
    });
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const guardLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    });
    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
            name: "identityAndSecurity",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), (0, $7Knp0._)({}, headerProps))
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, cardProps)),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
                    ]
                })
            ]
        })
    });
};
var $f8b4fa8d38716042$export$2e2bcd8739ae039 = $f8b4fa8d38716042$var$IdentityAndSecuritySection;

});

parcelRegister("g5q4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b52fde8f6e55b3$export$2e2bcd8739ae039; });
/* plan-and-track.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("lkWcW");
var $bjFQv = parcelRequire("bjFQv");
var $dCRJL = parcelRequire("dCRJL");

var $gxrnF = parcelRequire("gxrnF");
const $22b52fde8f6e55b3$var$sectionStyles = null;
const $22b52fde8f6e55b3$var$PlanAndTrackSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const jiraSofttwareHeaderText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.title",
        defaultMessage: "Plan & Track"
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: (0, $5ohHq.wacToken)("color.primary.blue")
    };
    const jiraSofttwareBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraBody",
        defaultMessage: "Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos."
    });
    const jiraSofttwareLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody",
        defaultMessage: "Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira."
    });
    const jirProductDiscoveryLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const tryCloud = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const jiraLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
    const jpdLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
    const jiracardProps = {
        logo: jiraLogo,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: jpdLogo,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0qvbgk _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), (0, $7Knp0._)({}, headerProps))
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, jiracardProps)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), (0, $7Knp0._)({}, jpdcardProps))
                ]
            })
        ]
    });
};
var $22b52fde8f6e55b3$export$2e2bcd8739ae039 = $22b52fde8f6e55b3$var$PlanAndTrackSection;

});

parcelRegister("1SKTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71995569305677b7$export$2e2bcd8739ae039; });
/* support-and-fix-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $dCRJL = parcelRequire("dCRJL");

var $bjFQv = parcelRequire("bjFQv");

var $gxrnF = parcelRequire("gxrnF");
/* Cards */ const $71995569305677b7$var$JsmCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.jsmCard.bodyText",
        defaultMessage: "Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast."
    });
    const localizedCtaText = intl.formatMessage((0, $gxrnF.messages).tryCloud);
    const jsmLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
        logo: jsmLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $71995569305677b7$var$StatusCard = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=statuspage");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.statusCard.bodyText",
        defaultMessage: "Incidents happen. Keep your users informed with fewer support emails during downtime."
    });
    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });
    const statusPageLogo = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "statuspage",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCRJL.TryPageCard), {
        logo: statusPageLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $71995569305677b7$var$sectionStyles = null;
const $71995569305677b7$var$SupportAndFixSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.headerText",
        defaultMessage: "Support & fix"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "support-and-fix",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bjFQv.TryPageHeader), {
                        dividerColor: "#ff8b00",
                        headerText: headerText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($71995569305677b7$var$JsmCard, {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)($71995569305677b7$var$StatusCard, {})
                    ]
                })
            ]
        })
    });
};
var $71995569305677b7$export$2e2bcd8739ae039 = $71995569305677b7$var$SupportAndFixSection;

});




parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});


var $f788Q = parcelRequire("f788Q");

var $kTri3 = parcelRequire("kTri3");
(0, $f788Q.init)((0, $kTri3.TryPage));


//# sourceMappingURL=try-page.b49c0d43.js.map
